import { AirlineLiteModel } from 'api-hooks/airline';
import { CruiseLiteModel } from 'api-hooks/cruise';
import { HotelLiteModel } from 'api-hooks/hotel';
import { Expose, Type } from 'class-transformer';
import {
  ActivityTypeEnum,
  SaleDepartmentEnum,
  DocumentTypeEnum,
} from 'common/constants/enum';
import {
  CommonModel,
  CommonParamInput,
} from 'common/repositories/common.model';

export type CommissionType = 'fixed' | 'percentage';

export type CommissionStatusType = 'active' | 'inactive' | 'upcoming';

export class CommissionAdditionalModel {
  id: string;
  type: CommissionType;

  commissionable:
    | ActivityTypeEnum
    | DocumentTypeEnum
    | AirlineLiteModel
    | CruiseLiteModel
    | HotelLiteModel;

  @Expose({ name: 'lead_commission' })
  @Type(() => Number)
  leadCommission: number;

  @Expose({ name: 'operator_sales_commission' })
  @Type(() => Number)
  operatorSalesCommission: number;
}

export class CommissionLiteModel extends CommonModel {
  department: SaleDepartmentEnum;

  @Expose({ name: 'applied_on' })
  @Type(() => Date)
  appliedOn: Date;

  @Expose({ name: 'has_base_commission' })
  hasBaseCommission: boolean;

  @Expose({ name: 'lead_commission' })
  @Type(() => Number)
  leadCommission: number;

  @Expose({ name: 'operator_sales_commission' })
  @Type(() => Number)
  operatorSalesCommission: number;

  type: CommissionType;

  @Expose({ name: 'is_active' })
  isActive: boolean;

  @Expose({ name: 'commission_master_additionals' })
  @Type(() => CommissionAdditionalModel)
  commissionMasterAdditionals: CommissionAdditionalModel[];
}

export class CommissionModel extends CommissionLiteModel {}

// query input

export type getCommissionsInputFilter = {
  status?: CommissionStatusType;
  department?: string;
  type?: string;
  applied_on_after?: Date;
  applied_on_before?: Date;
};

export type getCommissionsInput = {
  params: CommonParamInput<object, getCommissionsInputFilter>;
};

export type getCommissionInput = {
  id: string;
};

// mutation input
export type CommissionDetailMutationInput = {
  type: string;
  commissionable: string;
  leadCommission: number;
  operatorSalesCommission: number;
};

export type CommissionMutationInput = {
  department: string;
  appliedOn: Date;
  hasBaseCommission: boolean;
  leadCommission: number | null;
  operatorSalesCommission: number | null;
  type: string | null;
  commissionMasterAdditionals: CommissionDetailMutationInput[];
};

export type CommissionMutationUpdateInput = {
  id: string;
  body: CommissionMutationInput;
};

export type CommissionMutationDeleteInput = {
  id: string;
};
